// Compatibility for older bookmarks. Review #4 opens the payment popup inside
// the same #3 order and uses its customer/work-scoped basket and payment state.
import type { ReactNode } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { SARAH } from '../../data/mockData.js';

export function PaymentReviewScreen(): ReactNode {
  const { customerId = SARAH.id } = useParams();
  const location = useLocation();
  return <Navigate to={'/build-order/' + encodeURIComponent(customerId)} replace
    state={{ ...(location.state && typeof location.state === 'object' ? location.state : {}), openPayment: true }} />;
}

export default PaymentReviewScreen;
